import { AppEnvironment } from './environment.model';

/** Development (`--configuration=dev` | `development`). */
export const environment: AppEnvironment = {
  production: false,
  apiBaseUrl: '/api',
  envName: 'dev',
  jdChatSockJsPath: '/api/chat/ws-chat',
  candidateDocumentUploadViaPresignedUrl: false,
  liveTranscriptionWsOrigin: 'wss://api.calling.iconma.in/api/ws/session',
  liveTranscriptionWsOriginPrescreening: 'wss://api.prescreen.iconma.in/api/ws/session',
  liveTranscriptionWsOriginTechnical: 'wss://api.videointerview.iconma.in/ws/conversations',
  joinHumanApiUrlInterest: 'https://api.calling.iconma.in/api/join-human',
  joinHumanPhoneNumberInterest: '17323841970',
  callQuestionsApiUrlInterest: 'https://api.calling.iconma.in/api',
  joinHumanApiUrlPrescreening: 'https://api.prescreen.iconma.in/api/join-human',
  joinHumanPhoneNumberPrescreening: '17323841970',
  joinHumanApiUrl: 'https://api.prescreen.iconma.in/api/join-human',
  joinHumanPhoneNumber: '17323841970',
  browserTakeover: {
    apiBaseUrl: 'https://api.prescreen.iconma.in',
    wssUrl: 'wss://api.prescreen.iconma.in/ws',
    sipHost: 'api.prescreen.iconma.in',
    sipUser: 'webrtc_agent',
    sipPassword: '$PTic0nma',
  },
  callQuestionsApiUrlPrescreening: 'https://api.prescreen.iconma.in/api',
  liveTranscriptionClientPersist: false,
  livekitApiBaseUrl: 'https://api.videointerview.iconma.in',
  livekitUrlFallback: 'wss://meeting.iconma.in',
};
